// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"251ed781","726":"9e236543","787":"9b34e7c4"}[chunkId] + ".chunk.js";
};